import Typed from 'typed.js';

if( document.querySelector( '.js--typed-subscribed' ) ) {
  let typedSubscribedOptions = {
    strings: ["Delivers","Investigates","Is Independent"],
    typeSpeed: 40,
    loop: true,
    // startDelay: 500,
    // smartDelay: 5000,
    backSpeed: 50,
    backDelay: 1000,
    smartBackspace: true
  }

  let subscribeType = new Typed(".js--typed-subscribed", typedSubscribedOptions );
}

if( document.querySelector( '.js--typed-category' ) ) {
  let typedCategoryOptions = {
    stringsElement: '#js--typed-content',
    typeSpeed: 40,
    // startDelay: 5000,
    // smartDelay: 5000,
    backSpeed: 50,
    backDelay: 1000,
    smartBackspace: true
  }

  let subscribeType = new Typed(".js--typed-category", typedCategoryOptions );
}
